import { createContext } from 'react';

export interface IRoadmapPageContextProps {
    showCompletedEvents: boolean;
    setShowCompletedEvents: (showCompletedEvents: boolean) => void;
}

export const roadmapPageContext = createContext<IRoadmapPageContextProps | null>(null);
